module.exports = __webpack_public_path__ + "img/suspend.2980e1ef.svg";